<!--理赔说明-->
<template>
  <div class="comp-claim">
    <!-- 内容区 -->
    <div class="cont">
      <div class="hd">{{name}}</div>
      <img src="@/assets/images/claim-notice.jpeg">
      <p>
        线上理赔可覆盖90%案件，点击此处进一步了解
        <a href="javascript:;" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/notice/online_claim.html">《线上理赔介绍》</a>
        、本产品
        <a href="javascript:;" @click="goToThirdPage($event)" data-url="https://m.health.pingan.com/share/page/34/101.html">《理赔须知》</a>
      </p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'claim',
  data() {
    return {
      name: '理赔说明',
    }
  },
  props: {
  },
  computed: {
    
  },
  methods: {
    // 跳转到其他页面
    goToThirdPage(e) {
      let url = e.target.getAttribute('data-url');
      let title = e.target.text || '';
      this.$router.push({
        name: 'ThirdPage',
        query: {
          url: url,
          title: title
        }
      })
    },
  },
  created() {

  }
}
</script>
<style scoped lang="stylus">
  .comp-claim
    width: 100%
    background-color: #fff
    margin-top: .2rem
    .cont
      width: 100%
      .hd
        height: 1.14rem
        line-height: 1.14rem
        padding: 0 .3rem
        font-size: .34rem
        font-weight: 500
        color: #333
      img
        display: block
        width: 100%
        height: 100%
      p
        margin: 0 .3rem
        padding-bottom: .3rem
        font-size: .26rem
        color: #666
        line-height: .4rem
</style>
